import React, {useState, useEffect, useRef} from 'react';
import {Form, Formik} from 'formik';
import {CustomInput} from '../../Components/Input';
import s from './RegistrationNewClient.module.css';
import style from '../../assets/common/CommonStyle.module.css';
import LightGreenButton from '../../Components/Buttons/LightGreenButton';
import {
	useGenerateCodeMutation,
	useApproveCodeMutation,
} from '../../redux/userApi';
import PhoneInput from 'react-phone-input-2';
import {useTranslation} from 'react-i18next';

import {handleApiCall} from '../../assets/utils/utils';
import {toast} from 'react-toastify';
//import VeryLightGreenButton from '../../Components/Buttons/VeryLightGreenButton';
//import GreenButton from '../../Components/Buttons/GreenButton';
type Props = {
	setPhone: (p: string) => void;
	phone: string;
	error: string;
};
const ApprovePhoneForm: React.FC<Props> = ({setPhone, phone, error}) => {
	const {t, i18n} = useTranslation();

	const [generateCode, {isLoading: isGeneratingCode}] =
		useGenerateCodeMutation();
	const [approveCode, {isLoading: isApprovingCode}] = useApproveCodeMutation();
	const [countdown, setCountdown] = useState<number>(0);
	const intervalRef = useRef<NodeJS.Timeout | null>(null);

	const initialValues = {
		phone: phone,
		code: '',
		lang: i18n.language || '',
		country: i18n.language || '',
	};

	// Очистка интервала при размонтировании
	useEffect(() => {
		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
			}
		};
	}, []);

	// Управление таймером
	useEffect(() => {
		if (countdown > 0) {
			intervalRef.current = setInterval(() => {
				setCountdown((prev) => {
					if (prev <= 1) {
						if (intervalRef.current) {
							clearInterval(intervalRef.current);
						}
						return 0;
					}
					return prev - 1;
				});
			}, 1000);
		}

		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
			}
		};
	}, [countdown]);

	const handleGetSms = async () => {
		const generateCodeData = {
			phone: phone,
			country: i18n.language || '',
		};
		await handleApiCall({
			apiCall: () => generateCode(generateCodeData),
			onSuccess: (data) => {
				toast.success(data.message.textmsg);
				// Запускаем таймер на 60 секунд при успешной отправке
				setCountdown(60);
			},
		});
	};
	const handleApprovePhone = async (code: string) => {
		const approvePhoneData = {
			phone: phone,
			code: code,
		};
		await handleApiCall({
			apiCall: () => approveCode(approvePhoneData),
			onSuccess: (data) => toast.success(data.message.textmsg),
		});
	};
	return (
		<Formik
			initialValues={initialValues}
			onSubmit={(values) => {
				console.log(values);
			}}
		>
			{({values, handleSubmit}) => {
				return (
					<Form onSubmit={handleSubmit}>
						<div className={s.topInput}>
							<div className={s.inputName}>{t('Підтвердження номера')}</div>
							<div className={`${s.phoneApproveInput}`}>
								<PhoneInput
									inputClass={error && style.error}
									inputStyle={{}}
									country={'ua'}
									onlyCountries={['ua']}
									value={phone}
									countryCodeEditable={false}
									onChange={(value) => {
										setPhone(value);
									}}
								/>

								{/*<Field onChange={({currentTarget}) => {
                                setPhone(currentTarget.value)
                            }} name={"phone"} value={phone}
                                   placeholder={apiData.text_phonePlaceholder}/>*/}
							</div>
						</div>
						<div className={s.bottomData}>
							<div className={s.inputName}>{t('Підтвердіть зміну номера')}</div>
							<div className={s.content}>
								<div className={s.buttons}>
									<LightGreenButton
										type={'button'}
										onClick={handleGetSms}
										text={
											countdown > 0
												? `${t('ОТРИМАТИ смс')} (${countdown}с)`
												: t('ОТРИМАТИ смс')
										}
										loading={isGeneratingCode}
										disabled={isGeneratingCode || countdown > 0}
									/>
									<button className={s.whiteButton}>
										{t('СКАСУВАТИ НОМЕР')}
									</button>
								</div>
								<div className={`${s.phoneApproveInput}`}>
									<CustomInput
										name={'code'}
										placeholder={t('Код СМС')}
										autoComplete="one-time-code"
									/>
									<LightGreenButton
										type={'button'}
										onClick={() => handleApprovePhone(values.code)}
										text={t('Відправити')}
										loading={isApprovingCode}
										disabled={isApprovingCode}
									/>
								</div>
							</div>
						</div>
					</Form>
				);
			}}
		</Formik>
	);
};

export default ApprovePhoneForm;
